import otpService from "./OtpService";

export const OtpService = {
  generateOtp: otpService.generate,
  verifyOtp: otpService.verify
};
